import { type FC, useCallback } from "react";
import { useFormContext } from "react-hook-form";
import { Presentation } from "./Presentation";
import { useCredentialOptions } from "./useCredentialOptions";
import { type FormValues } from "../../schema";

type Props = {
  jobTypeName: string;
  experienceName: string;
  credentialUrl: string;
};

export const CredentialSelector: FC<Props> = ({ jobTypeName, experienceName, credentialUrl }) => {
  const {
    watch,
    setValue,
    formState: { errors },
  } = useFormContext<FormValues>();

  const selectedCredentials = watch("credentials");
  const jobTypeExperienceId = watch("experience");
  const { credentials, error } = useCredentialOptions(credentialUrl, Number(jobTypeExperienceId));

  const handleChangeCredential = useCallback(
    (credentialId: number, willFlag: boolean) => {
      setValue("credentials", {
        ...selectedCredentials,
        [String(credentialId)]: { willFlag },
      });
    },
    [selectedCredentials, setValue],
  );

  const handleSelectNone = useCallback(
    (credentialId: number) => {
      setValue("credentials", {
        ...selectedCredentials,
        [String(credentialId)]: { willFlag: null },
      });
    },
    [selectedCredentials, setValue],
  );

  const credentialsError = errors.credentials;
  const getErrorMessage = (): string | undefined => {
    if (credentialsError && "message" in credentialsError) {
      return credentialsError.message as string | undefined;
    }
    return undefined;
  };

  const validationErrorMessage = getErrorMessage();

  return (
    <Presentation
      jobTypeName={jobTypeName}
      experienceName={experienceName}
      credentials={credentials}
      selectedCredentials={selectedCredentials}
      onChangeCredential={handleChangeCredential}
      onSelectNone={handleSelectNone}
      errorMessage={error || validationErrorMessage}
    />
  );
};
